export default "__VITE_ASSET__DlgTPTSi__"